import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { VideoPlayer } from '../VideoPlayer';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: i * 0.15,
      ease: 'easeOut'
    }
  })
};
export function HeroSection() {
  const ref = useRef(null);
  const inView = useInView(ref, {
    once: true,
    amount: 0.2
  });
  return <section className="relative w-full bg-[#1A2B4A] dot-texture overflow-hidden" style={{
    paddingTop: '48px',
    paddingBottom: '100px'
  }} data-id="element-291">
      {/* Ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[#4ECDC4]/10 rounded-full blur-[120px] pointer-events-none" data-id="element-292" />

      <div ref={ref} className="max-w-5xl mx-auto px-6 flex flex-col items-center text-center" data-id="element-293">
        {/* Logo */}
        <motion.div custom={0} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="mb-8" data-id="element-294">
          <img src="https://cdn.magicpatterns.com/uploads/7VaFeJZzD28sKMP5WawxYb/HIRE_White_Logo.png" alt="The Hire Advantage" className="h-12 sm:h-14 object-contain" data-id="element-295" />
        </motion.div>

        {/* Badge */}
        <motion.div custom={1} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} data-id="element-296">
          <span className="inline-block bg-[#4ECDC4] text-[#1A2B4A] text-xs font-bold uppercase px-3 py-1 rounded-full mb-6 tracking-wider" data-id="element-297">
            Done-For-You D2D Recruiting
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 custom={2} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="text-[2rem] sm:text-5xl md:text-6xl font-black text-white leading-[1.1] mb-6" data-id="element-298">
          Stop Chasing Applicants.
          <br data-id="element-299" />
          <span className="text-[#4ECDC4]" data-id="element-300">Get a Recruiting System.</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p custom={3} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="text-lg sm:text-xl text-white/70 max-w-2xl mb-10 leading-relaxed" data-id="element-301">
          We build the system that delivers 20–50 qualified interviews every
          month. No guesswork. No chaos. Just consistent hires.
        </motion.p>

        {/* Video */}
        <motion.div custom={4} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="w-full max-w-sm mb-10 rounded-2xl overflow-hidden ring-1 ring-[#4ECDC4]/20 shadow-2xl shadow-[#4ECDC4]/10" data-id="element-302">
          <VideoPlayer data-id="element-303" />
        </motion.div>

        {/* CTA */}
        <motion.div custom={5} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="mb-12" data-id="element-304">
          <CTAButton size="large" data-id="element-305" />
        </motion.div>

        {/* Stat pills */}
        <motion.div custom={6} variants={fadeUp} initial="hidden" animate={inView ? 'visible' : 'hidden'} className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-3xl" data-id="element-306">
          <div className="bg-white/10 backdrop-blur-sm border border-[#4ECDC4]/30 rounded-2xl px-6 py-5 flex flex-col items-center" data-id="element-307">
            <span className="text-3xl font-black text-[#4ECDC4]" data-id="element-308">4,000+</span>
            <span className="text-sm text-white/70 mt-1 text-center" data-id="element-309">
              System Hires
            </span>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-[#4ECDC4]/30 rounded-2xl px-6 py-5 flex flex-col items-center" data-id="element-310">
            <span className="text-3xl font-black text-[#4ECDC4]" data-id="element-311">$150M+</span>
            <span className="text-sm text-white/70 mt-1 text-center" data-id="element-312">
              Production from Hired Reps
            </span>
          </div>
          <div className="bg-white/10 backdrop-blur-sm border border-[#4ECDC4]/30 rounded-2xl px-6 py-5 flex flex-col items-center" data-id="element-313">
            <span className="text-3xl font-black text-[#4ECDC4]" data-id="element-314">
              20+ Years
            </span>
            <span className="text-sm text-white/70 mt-1 text-center" data-id="element-315">
              Built by D2D Operators
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}